import { useQuery, UseQueryResult } from 'react-query';
import { AthletePackageRetrieve } from 'types';
import { client } from 'utils/api-client';

function useAthletePackage(
  athletePackageId: string | undefined,
): UseQueryResult<{ data: AthletePackageRetrieve }> {
  return useQuery(
    ['athletePackages', athletePackageId],
    () => client.get(`athlete-packages/${athletePackageId}/`),
    {
      enabled: !!athletePackageId,
    },
  );
}

export default useAthletePackage;
